import React from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Provider, connect } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Dashboard from '../dashboard';
import AppHeader from '../components/AppHeader';
import './App.scss';
import NoData from '../nodata';
import configureStore from '../store';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const store = configureStore();

const theme = createMuiTheme({
	palette: {
		type: 'dark',
		primary: {
			main: '#303941',
			dark: '#202736',
			contrastText: '#d5ecfe',
		},
		secondary: {
			main: '#4c6691',
			dark: '#204076',
			//contrastText: '#7c8393'
		},
		background: {
			paper: '#272e3c',
			default: '#202736',
		},
		text: {
			primary: '#d5ecfe',
			secondary: '#cbd1e1',
		},
	},
	typography: {
		fontFamily: 'Calibri,sans-serif',
	},
});

const useStyles = makeStyles((theme) => ({
	content: {
		height: 'calc(100% - 120px)',
	},
	toolBar: {
		backgroundColor: '#114376',
		paddingLeft: theme.spacing(7),
	},
	title: {
		color: theme.palette.common.white,
		//textTransform: 'uppercase',
		fontSize: '1.075rem',
		fontWeight: 'bold',
	},
}));

const App = (props) => {
	const classes = useStyles();

	return (
		<MuiThemeProvider theme={theme}>
			<CssBaseline />
			<AppHeader title='Visitors Register' />
			<Toolbar variant='dense' className={classes.toolBar}>
				<Typography className={classes.title} variant='subtitle2' noWrap></Typography>
			</Toolbar>

			<div className={classes.content}>
				<HashRouter>
					<Switch>
						<Route exact path='/' component={Dashboard} />
						<Route path='/:id' component={Dashboard} />
					</Switch>
				</HashRouter>
			</div>
		</MuiThemeProvider>
	);
};

const mapStateToProps = (state) => {
	const { header } = state;
	return {
		portfolio: '',
		effectiveDate: '',
	};
};

const AppStateFull = connect(mapStateToProps)(App);

const Root = () => {
	return (
		<Provider store={store}>
			<AppStateFull />
		</Provider>
	);
};

export default Root;
